module.exports = __webpack_public_path__ + "img/lowcode-2.1714746b.png";